<section class="content">
  <div class="container-fluid">
    <div class="block-header">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <ul class="breadcrumb breadcrumb-style ">
            <li class="breadcrumb-item">
              <h4 class="page-title">Transport Company</h4>
            </li>
            <!-- <li class="breadcrumb-item bcrumb-1">
              <a routerLink="/dashboard/main">
                <i class="fas fa-home"></i> Home</a>
            </li>
            <li class="breadcrumb-item bcrumb-2">
              <a href="#" onClick="return false;">Forms</a>
            </li>
            <li class="breadcrumb-item active">Basic</li> -->
          </ul>
        </div>
      </div>
    </div>
    <!-- <app-maser-page-header></app-maser-page-header> -->
    <div class="row">
      <div class="col" *ngIf="!vehicleTransportService.is_display_vehile_transport_register_component">

        <button mat-fab color="primary" (click)="registerVehicleTransport()">
          <mat-icon aria-hidden="false" aria-label="Example home icon">add</mat-icon>
        </button>
        <table mat-table [dataSource]="dataSource" style="width: 100%" matSort class="mat-elevation-z8">
          <!-- Position Column -->
          <ng-container matColumnDef="id">
            <th style="background: #97cdef;"  mat-header-cell *matHeaderCellDef mat-sort-header> ID</th>
            <td mat-cell *matCellDef="let element;let i=index"> {{i+1}}</td>
          </ng-container>

          <ng-container matColumnDef="transport_name">
              <th style="background: #97cdef;"  mat-header-cell *matHeaderCellDef mat-sort-header> Transport Name</th>
              <td mat-cell *matCellDef="let element">{{element.name}}</td>
            </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="contact_person">
            <th style="background: #97cdef;"  mat-header-cell *matHeaderCellDef mat-sort-header> Contact Person</th>
            <td mat-cell *matCellDef="let element">{{element.contact_person}}</td>
          </ng-container>

          <!-- Mobile Column -->
          <ng-container matColumnDef="mobile">
            <th style="background: #97cdef;"  mat-header-cell *matHeaderCellDef mat-sort-header> Mobile</th>
            <td mat-cell *matCellDef="let element">{{element.mobile}}</td>
          </ng-container>

          <!-- Address Column -->
          <ng-container matColumnDef="addresss">
            <th style="background: #97cdef;"  mat-header-cell *matHeaderCellDef mat-sort-header> Address</th>
            <td mat-cell *matCellDef="let element">{{element.address}}</td>
          </ng-container>


          <ng-container matColumnDef="edit">
            <th style="background: #97cdef;"  mat-header-cell *matHeaderCellDef mat-sort-header> Edit</th>
            <td mat-cell *matCellDef="let element" style="cursor: pointer;">
              <mat-icon (click)="editVehicleTransport(element)">edit</mat-icon>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>

      <div class="col-5" *ngIf="vehicleTransportService.is_display_vehile_transport_register_component">
        <div class="row">
          <div class="col"></div>
          <div class="col-1">
            <button mat-fab color="primary" (click)="hideVehicleTransportRegister()">
              <i class="material-icons">
                clear
              </i>
            </button>
          </div>
        </div>
        <app-vehicle-transport-register></app-vehicle-transport-register>
      </div>
    </div>
  </div>
</section>
